import '@babel/polyfill';

//Environment start
import Env from '@/lib/Env';
//Init function
import Init from '@/init';

// Vue lib
import Vue from 'vue';
Vue.config.productionTip = false;

// Bugsnag
import BugsnagClient, { bugsnagInit } from '@/utils/bugsnagClient';

bugsnagInit({
    apiKey: process.env.MIX_BUGSNAG_API_KEY,
});

Vue.prototype.$bugsnag = BugsnagClient;

//Init event bus
import EventBus from '@lib/EventBus';

// Vue prototype
Object.defineProperties(Vue.prototype, {
    $env: { get: () => Env },
    $bus: { get: () => EventBus },
});

// Vue libs
import Vuebar from 'vuebar';
Vue.use(Vuebar);

import Flicking from '@egjs/vue-flicking';
import '@egjs/vue-flicking/dist/flicking.css';
Vue.use(Flicking);

// import VueTheMask from 'vue-the-mask';
// Vue.use(VueTheMask);

import Multiselect from 'vue-multiselect';
Vue.component('multiselect', Multiselect);

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import Vuetify from '@/plugins/vuetify';
Vue.use(Vuetify);

import CKEditor from 'ckeditor4-vue';
Vue.use(CKEditor);

// App router
import router from '@/router';
// App store
import store from '@/store';
// App internationalization
import i18n from '@/i18n';

//Global components
import '@/components/.global';

//Mixins
import { events } from '@/mixins';
Vue.mixin(events);
import { componentState } from '@/mixins';
Vue.mixin(componentState);

//Utils
import '@/utils';

// App
import App from '@/App.vue';

Init()
    .then(({ created, mounted }) => {
        Env.log.debug('Creating vue instance');

        window.app = new Vue({
            el: '#app',
            i18n,
            router,
            store,
            vuetify: Vuetify,
            render: (h) => h(App),
            created,
            mounted,
        });
    })
    .catch((error) => {
        if (error == 'is_authorization') {
            return;
        }
        Env.log.error(error);
        BugsnagClient.notify(error);
    });

// Fix for hot reload recognizing changes in css
if (module.hot) {
    var hotEmitter = require('webpack/hot/emitter');
    hotEmitter.on('webpackHotUpdate', function (currentHash) {
        document.querySelectorAll('link[href][rel=stylesheet]').forEach((link) => {
            const nextStyleHref = link.href.replace(/(\?\d+)?$/, `?${Date.now()}`);
            link.href = nextStyleHref;
        });
    });
}
